export class ApellidoVariacion {
    [key: string]: string | number | undefined
    public id: number | undefined;
    public variacion: string | undefined;
    public apellido: string | undefined;
}